import Loadable from 'react-loadable';
import Loading from 'components/Loading';

const ManageSearch = Loadable({
  loader: () => import('./Containers/manage-search'),
  loading: Loading
});

export default [
  {
    path: '/search',
    component: ManageSearch,
    private: true,
    name: 'Search',
    menu: {
      name: 'Search',
      order: 1,
      icons: 'pe-7s-search'
    }
  }
];



// WEBPACK FOOTER //
// ./src/Search/routes.js